import { useEffect, useState } from "react";
import { FaRegEye, FaTimes } from "react-icons/fa";
import InnerImageZoom from "react-inner-image-zoom";
import ItemsCarousel from "react-items-carousel";
import { useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import ChatWithSeller from "../../Chat/ChatWithSeller/ChatWithSeller";
import SinglePageShimmer from "../../Products/SinglePageShimmer";
import ReactRating from "../ReactRate/RateStars";
import ShareButton from "./ShareButton";
import './SingleItem.css';
import { Button, Modal, } from 'reactstrap';

import { RiShareForwardLine } from "react-icons/ri";
import { createNotification } from "../CreateNotification";



const ShareModal = ({ isOpen, setIsOpen, link }) => {


  return (
    <Modal
      isOpen={isOpen}
      centered

    >
      <div
        onClick={() => { setIsOpen(false) }}
        className="position-absolute cursor-pointer"
        style={{ zIndex: 10, top: 0, right: 10, marginTop: '1rem', }}
      >
        <FaTimes size={20} />
      </div>
      <div style={{
        marginTop: '1rem',
        marginBottom: '1rem',

      }}>

        <div className="my-4 mx-3" style={{
        }}>
          <h5 style={{
            color: '#000'
          }}>Share via : </h5>
          <ShareButton />
        </div>
        <div className="border-bottom" />
        <div className="d-flex p-3 ">
          <div className="searchBox">
            <input type="text" className="copyInput" value={link} readOnly />
            <button className="copyButton" onClick={() => {
              navigator.clipboard.writeText(link)
              createNotification("success", "Link copied to clipboard")
            }
            }>Copy</button>
          </div>
        </div>
      </div>

    </Modal>
  )
}


const SingleItem = ({
  isShowMore = false,
  clsName = "col-12 col-xl-9",
  seller = {},
  fetchSingleProduct,
  isLoading = false,
  product,
  images,
  setVerifyOpen,
  setLoginOpen,
  showSeller = true,
  isApproved = true,
}) => {
  const user = useSelector((state) => state.user.user);
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const [activeThumbIndex, setActiveThumbIndex] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [link, setLink] = useState("");

  useEffect(() => {
    console.log('Hello ', user)
    if (user !== null) {
      if (user.is_verified === true) {
        setIsVerified(true);
      }
      try {
        fetchSingleProduct();

      } catch (error) {
        console.log(error);

      }
      setIsActive(true);

    } else {
      setIsVerified(false);
      setIsActive(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);
  useEffect(() => {
    setLink(window.location.href);
  }, [product])
  // const {pid} = useParams()
  return (
    <>
      {isLoading ? (
        <SinglePageShimmer />
      ) : (
        product && (
          <div className={`${clsName} d-flex flex-wrap`}>
            <div className="col-12 col-md-6">
              <ItemsCarousel
                key={"first"}
                requestToChangeActive={setActiveItemIndex}
                activeItemIndex={activeItemIndex}
                numberOfCards={1}
                gutter={20}
                leftChevron={
                  <div className="chevron">
                    <p>&#8249;</p>
                  </div>
                }
                rightChevron={
                  <div className="chevron">
                    <p>&#8250;</p>
                  </div>
                }
                disableSwipe={false}
                chevronWidth={40}
                alwaysShowChevrons={false}
              >
                {images.map((image, index) => {
                  return (
                    <figure key={index} className="product-image">
                      {/* <img src={`/assets/images/img-1.jpg`}
                                                    data-zoom-image={`/assets/images/img-1.jpg`}
                                                    alt="Water Boil Black Utensil" className={styles.carouselImage} /> */}
                      <InnerImageZoom
                        src={Object.values(image)[0]}
                        zoomSrc={Object.values(image)[0]}
                        zoomType="hover"
                        zoomPreload={true}
                        hideHint={true}
                        hideCloseButton={true}
                        alt={"product"}
                      />
                    </figure>
                  );
                })}
              </ItemsCarousel>
              <div className="py-2">
                <ItemsCarousel
                  key={"second"}
                  requestToChangeActive={setActiveThumbIndex}
                  activeItemIndex={activeThumbIndex}
                  numberOfCards={4}
                  leftChevron={
                    <div className="chevron">
                      <p>&#8249;</p>
                    </div>
                  }
                  rightChevron={
                    <div className="chevron">
                      <p>&#8250;</p>
                    </div>
                  }
                  disableSwipe={false}
                  chevronWidth={40}
                >
                  {images.map((image, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          border:
                            activeItemIndex === index
                              ? "2px solid #ec008c"
                              : "2px solid transparent",
                        }}
                        onClick={() => {
                          setActiveItemIndex(index);
                        }}
                        className="mt-2 cursor-pointer"
                      >
                        <img
                          src={Object.values(image)[0]}
                          alt=""
                          style={{
                            height: "75px",
                            width: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    );
                  })}
                </ItemsCarousel>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="d-flex flex-column ps-0 ps-md-3">
                <p className="section-lead fw-bold pb-0 mb-0">{product.name}</p>
                {/* <div className="d-flex my-auto text-secondary small fw-light">
                  <FaRegEye className="my-auto " style={{
                    marginRight: '0.2rem'
                  }} />
                  <span>{product.views}</span>&nbsp;
                </div> */}
                <p className="small p-0 m-0">
                  Purchased on: {product.date_of_purchase}
                </p>
                <div className="my-2">
                  <ReactRating isEnabled={false} rate={product.condition} />
                </div>
                <p className="item-list-price fw-bold">Rs. {product.price}</p>
                <div className="d-flex flex-wrap">
                  <p className="bg-success rounded me-2 d-block px-2 text-white small">
                    {product.gender === "m"
                      ? "Male"
                      : product.gender === "f"
                        ? "Female"
                        : "Unisex"}
                  </p>
                  <p className="bg-warning rounded d-block px-2 small">
                    {product.category_name}
                  </p>
                </div>
                <p style={{ fontSize: "14px", overflowWrap: "anywhere" }}>
                  {product.desc}
                </p>
                <div className="d-flex flex-wrap">
                  <p
                    className={`bg-${product.is_exchangeable === "1" ? "success" : "danger"
                      } rounded me-2 d-block px-2 py-1 text-white small`}
                  >
                    {product.is_exchangeable === "1" ? "" : "Non-"}Exchangable
                  </p>
                  <p
                    className={`bg-${product.is_refundable === "1" ? "success" : "danger"
                      } rounded d-block px-2 py-1 small text-white`}
                  >
                    {product.is_refundable === "1" ? "" : "Non-"}Refundable
                  </p>
                </div>
                {showSeller ? (
                  isActive ? (
                    <div className="p-2 border shadow rounded small">
                      <p className="m-0 p-0 lead fw-bold">Seller Details:</p>

                      <div className=" d-flex align-items-end justify-content-between ">
                        <div className="flex" style={{
                          paddingRight: '1rem'
                        }}>
                          <NavLink to={`/products/userallproducts/${seller.name}/${seller.id}`}
                            style={{ textDecoration: 'none', color: 'inherit' }} >
                            <div className="d-flex">
                              <img
                                src={
                                  seller.avatar ??
                                  "https://ui-avatars.com/api/?background=ec008c&color=ffffff&name=" +
                                  seller.name
                                }
                                width="30"
                                height="30"
                                className={` d-flex my-auto me-2`}
                                alt={user?.name}
                                style={{ borderRadius: "50%", objectFit: "cover" }}
                              />
                              <p className="sname my-auto p-0 fw-bold" style={{}}> {seller.name}</p>
                            </div>
                          </NavLink>
                          <p className="m-0 p-0">
                            <span className="fw-bold">Contact:</span> {seller.phone}{" "}
                          </p>
                          <p className="m-0 p-0">
                            <span className="fw-bold">Email:</span> {seller.email}{" "}
                          </p>
                          <p className="m-0 p-0">
                            <span className="fw-bold">City: </span>
                            {seller.city}{" "}
                          </p>
                        </div>
                      </div>

                    </div>
                  ) : isVerified ? (
                    <div className="p-2 border shadow rounded d-flex justify-content-center align-items-center">
                      <p className="m-0 p-0">
                        Please{" "}
                        <span
                          onClick={() => {
                            setVerifyOpen(true);
                          }}
                          className="cursor-pointer"
                          style={{ color: "#ec008c" }}
                        >
                          verify
                        </span>{" "}
                        your account to see seller details
                      </p>
                    </div>
                  ) : (
                    <div className="p-2 border shadow rounded d-flex justify-content-center align-items-center">
                      <p className="m-0 p-0">
                        Please{" "}
                        <span
                          onClick={() => {
                            setLoginOpen(true);
                          }}
                          className="cursor-pointer"
                          style={{ color: "#ec008c" }}
                        >
                          login
                        </span>{" "}
                        to see seller details
                      </p>
                    </div>
                  )
                ) : null}


                <div className="d-flex mt-2" style={{
                  gap: '.5rem'
                }}>
                  <div className=" d-flex mt-2">
                    <Button className="d-flex justify-content-center align-items-center" style={{
                      borderRadius: '1.2rem',
                      gap: '0.5rem'
                    }}>
                      <FaRegEye className=" h-5 w-5" />
                      {product.views}
                    </Button>
                  </div>
                  <div className=" d-flex mt-2">
                    <Button type="button" className="d-flex justify-content-center align-items-center" style={{
                      borderRadius: '1.2rem',
                      gap: '0.5rem',
                    }}
                      onClick={() => setIsOpen(true)}
                    >
                      <RiShareForwardLine className=" h-5 w-5" />
                      Share
                    </Button>
                    {
                      isOpen && <ShareModal isOpen={isOpen} setIsOpen={setIsOpen} link={link} />
                    }

                  </div>
                  {user && user.id !== seller.id && (
                    <ChatWithSeller
                      seller={seller}
                      productName={product.name}
                      productID={product.id}
                    />
                  )}



                  {/* <p className=" mb-1">Share via : </p>
                  <div>
                    {
                      isApproved ? (<ShareButton
                        productName={product.name}
                        productID={product.id} />) : <></>
                    }
                  </div> */}
                </div>
                {isShowMore && (
                  <Link
                    to={`/products/${product.id}/${product.name}`}
                    className="text-decoration-none"
                  >
                    <button
                      className="btn d-inline text-white"
                      style={{ background: "#369" }}
                    >
                      View Details
                    </button>
                  </Link>
                )}
              </div>
            </div>
          </div>
        )
      )}
    </>
  );
};

export default SingleItem;


